<template>
  <el-dialog
    :title="$t('editMenuGroup.editMenuGroup')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose">
    <el-form :model="editMenuGroupInfo" :rules="rules" ref="editForm">
      <el-form-item :label="$t('editMenuGroup.groupName')" prop="name">
        <el-input 
          v-model="editMenuGroupInfo.name" 
          :placeholder="$t('editMenuGroup.requiredGroupName')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('editMenuGroup.icon')" prop="icon">
        <el-input 
          v-model="editMenuGroupInfo.icon" 
          :placeholder="$t('editMenuGroup.requiredIcon')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('editMenuGroup.label')">
        <el-select 
          v-model="editMenuGroupInfo.label" 
          style="width:100%"
          :placeholder="$t('editMenuGroup.optionalLabel')">
          <el-option value="" :label="$t('editMenuGroup.optionalLabel')"></el-option>
          <el-option value="HOT" label="HOT"></el-option>
          <el-option value="TOP" label="TOP"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editMenuGroup.sequence')" prop="seq">
        <el-input 
          v-model="editMenuGroupInfo.seq" 
          :placeholder="$t('editMenuGroup.requiredSequence')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('editMenuGroup.groupType')">
        <el-select 
          v-model="editMenuGroupInfo.groupType" 
          style="width:100%"
          :placeholder="$t('editMenuGroup.optionalGroupType')">
          <el-option value="" disabled :label="$t('editMenuGroup.optionalGroupType')"></el-option>
          <el-option value="P_WEB" :label="$t('editMenuGroup.web')"></el-option>
          <el-option value="P_APP" :label="$t('editMenuGroup.app')"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editMenuGroup.storeType')">
        <el-select 
          v-model="editMenuGroupInfo.storeType" 
          style="width:100%"
          :placeholder="$t('editMenuGroup.selectStoreType')">
          <el-option value="" :label="$t('editMenuGroup.selectStoreType')"></el-option>
          <el-option value="800900000001" :label="$t('editMenuGroup.operationTeam')"></el-option>
          <el-option value="800900000005" :label="$t('editMenuGroup.merchant')"></el-option>
          <el-option value="800900000000" :label="$t('editMenuGroup.developmentTeam')"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editMenuGroup.description')">
        <el-input
          type="textarea"
          :rows="2"
          :placeholder="$t('editMenuGroup.optionalDescription')"
          v-model="editMenuGroupInfo.description">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="editMenuGroup">{{$t('common.save')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateMenuGroup } from '@/api/dev/menuGroupApi'

export default {
  name: 'EditMenuGroup',
  data() {
    return {
      dialogVisible: false,
      editMenuGroupInfo: {
        gId: '',
        name: '',
        icon: '',
        label: '',
        seq: '',
        description: '',
        groupType: '',
        storeType: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('editMenuGroup.groupNameRequired'), trigger: 'blur' },
          { min: 2, max: 10, message: this.$t('editMenuGroup.groupNameLength'), trigger: 'blur' }
        ],
        icon: [
          { required: true, message: this.$t('editMenuGroup.iconRequired'), trigger: 'blur' },
          { min: 2, max: 20, message: this.$t('editMenuGroup.iconLength'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('editMenuGroup.sequenceRequired'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('editMenuGroup.sequenceNumber'), trigger: 'blur' }
        ],
        gId: [
          { required: true, message: this.$t('editMenuGroup.groupIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.editMenuGroupInfo = { ...row }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.editForm.resetFields()
    },
    async editMenuGroup() {
      try {
        await this.$refs.editForm.validate()
        await updateMenuGroup(this.editMenuGroupInfo)
        this.$message.success(this.$t('editMenuGroup.editSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        if (error !== 'validate') {
          this.$message.error(error.message || this.$t('editMenuGroup.editFailed'))
        }
      }
    }
  }
}
</script>